import axios from 'axios'
import refreshAttribute from '../utils/refreshAttribute'

export default {
  name: 'dynamic-modal',

  ui: {
    job: '[js-dynamic-modal-job]',
    name: '[js-dynamic-modal-name]',
    img: '[js-dynamic-modal-img]',
  },

  events: [
    {
      on: 'click',
      handle (e) {
        e.preventDefault()
        if (!this.el.getAttribute('js-modal-control')) {
          if (this.props.type === 'members') {
            this.members()
          } else if (this.props.type === 'simple-text') {
            this.simpleText()
          } else {
            this.request()
          }
        }
      },
    },
  ],

  componentDidMount () {
    this.modalID = this.id = this.props.id
    this.id = this.props.id
  },

  request () {
    const formData = new FormData()
    formData.append('postid', this.props.id)
    formData.append('action', this.props.action)
    formData.append('nonce', this.props.nonce)

    const loader = document.createElement('div')
    loader.classList.add('loader')
    this.el.append(loader)
    this.el.classList.add('is-loading')

    axios.post(this.props.route, formData)
      .then((response) => {
        this.createModal(response.data.data)
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  },

  members () {
    this.createModal(`
      <div class="member-modal modal__inner flex">
        <button type="button" class="modal__close modal__close--light-grey center-content" js-modal-close>
          <svg width="28" height="28" class="icon icon--xdark-blue">
            <use href="#icon-close" xlink:href="#icon-close"></use>
          </svg>
          <span class="sr-only">Close</span>
        </button>

        <div class="w-full">
          <div class="modal__content">
            <div class="md:flex md:items-end mb-6 md:mb-10">
              <div class="relative modal__content-image">
                <div class="aspect-ratio aspect-ratio--140 md:aspect-ratio--131">
                  <img class="lazyload grayscale" data-src="${this.ui.img.src}" alt="${this.ui.name}">
                </div>
              </div>
              <div class="md:ml-10">
                <p class="mt-4 title-sans">${this.ui.name.innerHTML}</p>
                <p class="paragraph text-grey mt-2">${this.ui.job.innerHTML}</p>
              </div>
            </div>
            <div class="paragraph text-dark-grey">${this.el.dataset.desc}</div>
          </div>
        </div>
    </div>
    `)
  },

  simpleText () {
    let unescapedDesc = this.unescapeJsString(this.el.dataset.desc)
    this.createModal(`
      <div class="simple-text-modal modal__inner flex">
        <button type="button" class="modal__close modal__close--light-grey center-content" js-modal-close>
          <svg width="28" height="28" class="icon icon--xdark-blue">
            <use href="#icon-close" xlink:href="#icon-close"></use>
          </svg>
          <span class="sr-only">Close</span>
        </button>

        <div class="w-full">
          <div class="modal__content">
            <h2 class="title-sans title-sans--SM mb-8 md:mb-10">${this.el.dataset.title}</h2>
            <div class="paragraph text-dark-grey">${unescapedDesc}</div>
          </div>
        </div>
    </div>
    `)
  },
  
  unescapeJsString(str) {
    // Handle common JavaScript escape sequences
    str = str
        .replace(/\\n/g, '\n')    // Newline
        .replace(/\\r/g, '\r')    // Carriage return
        .replace(/\\t/g, '\t')    // Tab
        .replace(/\\f/g, '\f')    // Form feed
        .replace(/\\"/g, '"')     // Double quote
        .replace(/\\'/g, "'")     // Single quote
        .replace(/\\\\/g, '\\');  // Backslash

    // Handle Unicode escape sequences
    str = str.replace(/\\u([0-9a-fA-F]{4})/g, function (match, grp) {
        return String.fromCharCode(parseInt(grp, 16));
    });

    // Handle HTML closing tags escaped
    str = str.replace(/\\\//g, '/');

    return str;
  },

  createModal (data) {
    if (this.el.querySelector('.loader')) {
      this.el.querySelector('.loader').remove()
    }
    this.el.classList.remove('is-loading')

    const node = document.createElement('div')
    node.classList.add('modal', 'is-hidden')
    if (this.props.position) node.classList.add(this.props.position)
    node.id = `${this.props.model}-${this.modalID}`
    node.setAttribute('js-modal', '')

    // node.appendChild(stringToHTML(data))
    node.innerHTML = data
    this.el.setAttribute(
      'js-modal-control',
      `{'target': '#${this.props.model}-${this.modalID}'}`,
    )

    document.querySelector('.modals').appendChild(node)
    if (this.props.refreshAttribute) {
      this.props.refreshAttribute.forEach(el => {
        if (node.querySelector(`[${el}]`)) refreshAttribute(el)(node.querySelector(`[${el}]`))
      })
    }
    node.setAttribute(this.props.jsAttribute, '')

    setTimeout(() => {
      this.el.click()
    }, 300)
  },
}
